
import React from 'react';
import { withStyles } from '@material-ui/core';
import { Typography } from 'components';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  },
  image: {
    maxWidth: '100%',
    margin: '15px 0px'
  }
});

const IllustrationInfo = (props) => {
  const {
    classes,
    type = 'no-data', // no-data, lost-conection, no-chart
    message,
    style = 'image', // image, text
    width,
    ...rest
  } = props;

  let image;
  let notif;
  if (type === 'no-data') {
    image = '/image/no_data.png';
    notif = 'No Data';
  } else if (type === 'lost-conection') {
    image = '/image/no_connection.png';
    notif = 'Lost Conection';
  } else {
    image = '/image/no_data.png';
    notif = 'No Curve';
  }

  if (style === 'image') {
    return (
      <div className={classes.root} {...rest}>
        <img alt={type} src={image} className={classes.image} style={{ width: width || 300 }}/>
        <Typography variant='h5' type='bold' color='#0073D1' >Oopss!</Typography>
        <Typography color='#0073D1'>{message || notif}</Typography>
      </div>
    )
  } else {
    return (
      <div className={classes.root} {...rest}>
        <Typography type='bold' variant='body1' color='#00000047'>{message || notif}</Typography>
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(IllustrationInfo);
